<template>
  <MarketCard class="offer">
    <LinkWrapper
      :href="offferLink"
      target="_blank"
      :class="[classes.offerLink, 'offer-link']"
      @click="handleClick"
    >
      <div :class="classes.columnGroup">
        <div :class="classes.infoGroup">
          <OfferHeader
            v-show="!!offerHeader"
            :class="[classes.offerHeader, 'offer-header']"
          >
            {{ offerHeader }}
          </OfferHeader>

          <div :class="[classes.offerText]">
            <OfferFittedText
              :class="classes.offerTextBit"
              :offerText="offerText"
              alignment="center"
              justifyContent="center"
            />
          </div>
        </div>
        <div :class="classes.buttonWrapper">
          <Button :class="[classes.offerButton, 'offer-button']" />
        </div>
      </div>
    </LinkWrapper>
  </MarketCard>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import MarketCard from "../../styled/MarketCard.vue";
import Button from "./Button.vue";

import OfferHeader from "../../branded/OfferHeader.vue";
import OfferFittedText from "../../OfferFittedText.vue";
import LinkWrapper from "../../LinkWrapper.vue";

import { createUseStyles } from "@fresh8/ad-data-composition/src/theme";
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";
import { injectCardNumber, useAnalytics } from "../../../hooks/useAnalytics";
import { injectOffer } from "@fresh8/ad-data-composition/src/offer";

const { useStyles } = createUseStyles(
  {
    textWrapper: {
      flex: "1 1 0",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center"
    },
    columnGroup: {
      display: "grid",
      gridTemplateColumns: "3fr 1fr",
      height: "100%"
    },
    infoGroup: {
      display: "grid",
      gridTemplateRows: "25px auto"
    },
    offerHeader: {
      alignSelf: "center",
      justifySelf: " center",
      fontSize: "12px",
      textAlign: "center",

      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      padding: "0 6px",
      boxSizing: "border-box",
      lineHeight: 1
    },
    offerText: {
      padding: "0 6px",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      flex: 1,
      overflow: "hidden",
      position: "relative"
    },
    offerTextBit: {
      fontSize: "1rem",
      display: "flex",
      flexDirection: "column",
      position: "relative",
      marginTop: props => (props.hasHeader ? "initial" : "auto"),
      marginBottom: props => (props.hasHeader ? "initial" : "auto"),
      textAlign: "center"
    },
    offerButton: {
      height: "100%"
    },
    offerButtonWrapper: {
      padding: "6px"
    },
    resize: {
      pointerEvents: "none",
      zIndex: -99
    },
    buttonWrapper: {
      padding: "3px",
      borderLeft: props => `1px solid ${props.marketBorderColor}`
    },
    offerLink: {
      display: "flex",
      flex: 1,
      flexDirection: "column"
    }
  },
  undefined
);

export default defineComponent({
  name: "LeaderboardOffer",
  components: {
    OfferFittedText,
    MarketCard,
    Button,
    OfferHeader,
    LinkWrapper
  },

  setup(props) {
    const brandContext = injectBrand();
    const offerContext = injectOffer();
    const offerText = computed(
      () => offerContext?.offer.value && offerContext?.offer.value.body
    );
    const offerHeader = computed(() => offerContext?.offer.value?.header);
    const offferLink = computed(() => offerContext?.offer.value?.link || "#");

    const template = computed(() => ({
      ...(brandContext?.adTemplateBranding.value || {}),
      hasHeader: !!offerHeader.value
    }));

    const { classesRef } = useStyles(template);

    const cardNumber = injectCardNumber();

    const { handleClick } = useAnalytics(
      { cardNumber: cardNumber },
      "Offer Card"
    );

    return {
      offerText,
      classes: classesRef,
      offerHeader,
      offferLink,
      handleClick
    };
  }
});
</script>
